"use strict";
Object.defineProperty(exports, Symbol.toStringTag, { value: "Module" });
const jsxRuntime = require("react/jsx-runtime");
const components_overlay_Toggletip_hooks_useToggletip = require("../../../../chunks/useToggletip-BCyf9wPQ.js");
function ToggletipContainer({
  children,
  initialOpen,
  placement,
  open,
  onOpenChange,
  ...props
}) {
  const toggletip = components_overlay_Toggletip_hooks_useToggletip.useToggletip({ initialOpen, placement, open, onOpenChange });
  return /* @__PURE__ */ jsxRuntime.jsx(components_overlay_Toggletip_hooks_useToggletip.ToggletipContext.Provider, { value: toggletip, children: /* @__PURE__ */ jsxRuntime.jsx("div", { ...props, children }) });
}
exports.ToggletipContainer = ToggletipContainer;
